import { render } from "./HrWarnings.vue?vue&type=template&id=743e808c&scoped=true"
import script from "./HrWarnings.vue?vue&type=script&lang=js"
export * from "./HrWarnings.vue?vue&type=script&lang=js"

import "./HrWarnings.vue?vue&type=style&index=0&id=743e808c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743e808c"]])

export default __exports__